import Link from 'src/components/primitives/Link/Link';
import { WithChildren } from 'src/utils/UtilityTypes';
import { VELOCITY_DOCS_URL } from 'src/constants/constants';

export default function ReferencePriceTooltipContent({
	children,
}: WithChildren) {
	return (
		<>
			<p>Reference Price is currently used for trigger orders. {children}</p>
			<Link
				href={`${VELOCITY_DOCS_URL}/trading/all-order-types#trigger-order-mechanics`}
				openInNewTab
			>
				Learn more
			</Link>
		</>
	);
}
